import { css } from '@/styled-system/css';

export const calculatorStyles = css.raw({
  containerType: 'inline-size',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: 'default',
});

export const cardStyles = css.raw({
  containerType: 'inline-size',
  width: '100%',
  padding: 'default',
});

export const singlePropertyStyles = css.raw({
  width: '100%',
});

export const propertyGridStyles = css.raw({
  display: 'grid',
  width: '100%',
  gap: 'default',
  gridTemplateColumns: '1fr',
  '@container (min-width: 900px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
});

export const cardContentStyles = css.raw({
  display: 'flex',
  flexDirection: 'column',
  gap: 'default',
  overflowWrap: 'anywhere',
});

export const inputGridStyles = css.raw({
  display: 'grid',
  columnGap: 'default',
  rowGap: 'zero',
  gridTemplateColumns: '1fr',
  '@container (min-width: 400px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
});

export const inputFieldStyles = css.raw({
  gridRow: 'span 3',
  gridTemplateRows: 'subgrid',
  marginBlockEnd: 'default',
  '& > .c11n_label': { alignSelf: 'end' },
});

export const resultListStyles = css({
  margin: 'zero',
  '& dd': { margin: 'zero' },
});

export const resultRowStyles = css({
  display: 'flex',
  justifyContent: 'space-between',
  gap: 'default',
  paddingBlock: 'tight',
  borderBottomWidth: '1px',
  borderBottomStyle: 'solid',
  borderBottomColor: 'border.muted',
});

export const subtleTextStyles = css.raw({
  color: 'text.subtle',
});
